module.exports = __webpack_public_path__ + "static/media/shoppingCartDark.1dca3831.svg";